export default __webpack_public_path__ + "static/media/slot6.433d5a64.png";